import { useState } from "react";
import {
  Tab,
  TabGroup,
  TabList,
  TabPanel,
  TabPanels,
} from "@headlessui/react";
import { motion, LayoutGroup } from "framer-motion";
import Scrollbars from "react-custom-scrollbars-2";
import { classNames } from "../../helpers/classNames";

const Tabs = ({
  defaultActiveKey,
  items = [],
  selectedIndex,
  setSelectedIndex = () => { },
  content = true,
  tabsClass,
  type = "tabs",
  tabcontentBody="",
  underLineClass=""
}) => {
  const [internalTab, setInternalTab] = useState(defaultActiveKey || 0);

  const actualSelectedIndex =
    typeof selectedIndex === "number" ? selectedIndex : internalTab;

  const handleTabChange = (index) => {
    setInternalTab(index);
    if (typeof setSelectedIndex === "function") setSelectedIndex(index);
  };

  return (
    <TabGroup
      selectedIndex={actualSelectedIndex}
      onChange={handleTabChange}
      className="h-full"
    >
      <div className={classNames(type === "menu" ? "flex" : "")}>
        {type === "tabs" && (
          <LayoutGroup id="tabs-layout-group">
            <Scrollbars autoHide className="!h-10 [&>div]:flex [&>div]:h-full lg:[&>div]:h-auto">
              <TabList className={classNames("flex gap-6 relative before:content-[''] before:absolute before:w-full before:bottom-0 before:left-0 before:border-b-2 before:border-gray-300", tabsClass)}>
                {items?.map((tab, i) => (
                  <Tab
                    disabled={tab?.disabled || false}
                    key={i}
                    className={classNames(
                      "relative border-b-2 border-transparent pb-3 text-sm font-bold",
                      i === actualSelectedIndex
                        ? "text-denim"
                        : "text-gray-600 hover:text-denim font-bold",
                      tab?.disabled ? "opacity-50 cursor-not-allowed" : ""
                    )}
                  >
                    <div className="flex gap-2 items-center">
                      {tab?.icon && (
                        <i className={classNames("fa-fw", tab?.icon)}></i>
                      )}
                      <span className="whitespace-nowrap">{tab?.label}</span>
                    </div>
                    {i === actualSelectedIndex && (
                      <motion.div
                        layoutId="tab-underline"
                        className={classNames("h-[2px] bg-denim w-full absolute left-0 -bottom-[1.6px]",underLineClass)}                     
                      />
                    )}
                  </Tab>
                ))}
              </TabList>
            </Scrollbars>
          </LayoutGroup>
        )}

        {type === "menu" && (
          <TabList
            className={classNames(
              "flex flex-col min-w-52 max-w-fit",
              tabsClass
            )}
          >
            {items?.map((tab, i) => (
              <Tab
                disabled={tab?.disabled || false}
                key={i}
                className={classNames(
                  "relative px-4 py-2 w-fit text-sm font-medium",
                  i === actualSelectedIndex
                    ? "text-primary"
                    : "text-gray-500",
                  tab?.disabled ? "opacity-50 cursor-not-allowed" : ""
                )}
              >
                <div className="flex gap-2 items-center">
                  {tab?.icon && (
                    <i className={classNames("fa-fw", tab?.icon)}></i>
                  )}
                  <span className="whitespace-nowrap">{tab?.label}</span>
                </div>
              </Tab>
            ))}
          </TabList>
        )}

        {content && (
          <TabPanels
            className={classNames(
              "h-[calc(100%-90px)]",
              type === "menu" ? "flex-grow px-3" : "mt-5", tabcontentBody
            )}
          >
            {items?.map((tab, i) => (
              <TabPanel key={i} className="h-full focus:outline-none">
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: 15 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="h-full"
                >
                  {/* If using Component prop instead of content prop: */}
                  {tab.Component ? <tab.Component /> : tab.content}
                </motion.div>
              </TabPanel>
            ))}
          </TabPanels>
        )}
      </div>
    </TabGroup>
  );
};

export default Tabs;
